<template>
  <div class="h-[6px] rounded-full bg-surface-200 relative overflow-hidden">
    <div
      class="absolute left-0 h-full bg-primary-600 rounded-full duration-500 ease-out"
      :style="{ width: `${Math.max(Math.min(progress, 100), 0)}%` }"
    ></div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  progress: {
    type: Number,
    required: true,
  },
})
</script>
